// extracted by mini-css-extract-plugin
export var animationContainer = "_os-0";
export var footer = "_os-1";
export var gray = "_os-2";
export var lineItem = "_os-3";
export var lineItemImage = "_os-4";
export var lineItemInfo = "_os-5";
export var lineItemText = "_os-6";
export var lineItems = "_os-7";
export var modalContent = "_os-8";
export var options = "_os-9";
export var orderName = "_os-a";
export var refundAmount = "_os-b";